import {
  COMMUNITY_FILE_EXTENSIONS,
  COMMUNITY_FILE_MIME_TYPES,
  COMMUNITY_IOS_IMAGE_EXTENSIONS,
  PORTAL_FILE_EXTENSIONS,
  PORTAL_FILE_MIME_TYPES,
} from '@src/constants/fileTypes';

export interface EditorConfig {
  maxFiles: number;
  maxSize: number;
  acceptedFileTypes: string[];
  acceptedFileExtensions: string[];
  iosFileExtensions?: string[];
}

export const CommunityEditorConfig: EditorConfig = {
  maxFiles: 5,
  maxSize: 10 * 1024 * 1024,
  acceptedFileTypes: COMMUNITY_FILE_MIME_TYPES,
  acceptedFileExtensions: COMMUNITY_FILE_EXTENSIONS,
  iosFileExtensions: COMMUNITY_IOS_IMAGE_EXTENSIONS,
};

export const PortalEditorConfig: EditorConfig = {
  maxFiles: Infinity,
  maxSize: 25 * 1024 * 1024,
  acceptedFileTypes: PORTAL_FILE_MIME_TYPES,
  acceptedFileExtensions: PORTAL_FILE_EXTENSIONS,
};
